import Vue from 'vue';
import order from '../../api/order.js';

import * as types from '../mutation-types';

const state = {
  active_order: {
    status: '',
  },
  active_gateway_order: {
    data: {
      money_order_message: '',
    }
  },
};

// getters
const getters = {
  active_order: (state) => state.active_order,
  active_gateway_order: (state) => state.active_gateway_order,
};

// actions
const actions = {
  get_order_status ({commit, state}, parameters) {
    order.statusOrder(parameters.module_id, parameters.order_id, parameters.unique_id,
      (response) => {
        console.log('Success:', response);
        commit(types.SET_ORDER_STATUS, {
          status: response.data.data.status
        });
      },
      (response) => {
        console.error('Response:', response);
        // error on the call.
      }
    );
  },
  get_order_gateway ({commit, state}, parameters) {
    order.statusGateway(parameters.module_id, parameters.order_id,
      (response) => {
        commit(types.SET_ORDER_GATEWAY, {
          data: response.data
        });
      },
      (response) => {
        console.error('Response:', response);
        // error on the call.
      }
    );
  },
};

// mutations
const mutations = {
  [types.SET_ORDER_STATUS] (state, parameters) {
    let active_order = Object.assign({}, state.active_order);
    active_order.status = parameters.status;

    Vue.set(state, 'active_order', active_order);
  },
  [types.SET_ORDER_GATEWAY] (state, parameters) {
    let active_gateway_order = Object.assign({}, state.active_gateway_order);
    active_gateway_order = parameters.data.data;

    Vue.set(state, 'active_gateway_order', active_gateway_order);
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/Order.js